export enum RelationType {
  PARENT = 0,
  REQUESTED = 1,
  REJECTED = 2,
  ACCEPTED = 3,
  REVOKED = 4
}
